import { db } from "@modules/local/db";
import { useAppSelector } from "@lib/stores";
import { useAppLiveQuery } from "@modules/local/hooks";

const useCurrentPlan = () => {
  const userId = useAppSelector((state) => state.auth.user.id);
  const { result: plans } = useAppLiveQuery(
    () => db.readerPlans.get(userId ?? ""),
    [userId]
  );

  return { plan: plans?.plans?.[0] ?? null };
};

export default useCurrentPlan;
